import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Footer.css';

const Footer = () => {
  const navigate = useNavigate();

  // Navigation handler function
  const handleDestinationClick = (destinationName) => {
    // Convert destination name to lowercase and remove spaces for URL
    const destinationKey = destinationName.toLowerCase().replace(/\s+/g, '');
    navigate(`/destinations/${destinationKey}`);
  };

  // First 8 destinations from Destinations component + 1 custom
  const footerDestinations = [
    'KERALA', 'KASHMIR', 'HIMACHAL', 'KARNATAKA', 
    'UTTARAKHAND', 'TAMIL NADU', 'MADHYA PRADESH', 'RAJASTHAN', 
    'CUSTOM'
  ];

  return (
    <div className="footer-container">
      <div className="footer-content">
        <div className="row">
          <div className="col-lg-4 col-md-6 mb-4">
            <div className="footer-section">
              <h5>QUICK LINKS</h5>
              <ul>
                <li><a href="/about">ABOUT US</a></li>
                <li>
                  <a
                    href="#"
                    onClick={e => {
                      e.preventDefault();
                      if (window.showContactCardOverlay) window.showContactCardOverlay();
                    }}
                  >
                    CUSTOMISE TRIPS
                  </a>
                </li>
                <li><a href="/contact">CONTACT US</a></li>
                <li><a href="/policy">CANCELLATION POLICY</a></li>
                <li><a href="/policy">REFUND POLICY</a></li>
              </ul>
            </div>
          </div>
          
          <div className="col-lg-3 col-md-6 mb-4">
            <div className="footer-section">
              <h5>MORE</h5>
              <ul>
                <li><a href="/contact">PARTNER WITH US</a></li>
                <li><a href="/privacy">TERMS & CONDITIONS</a></li>
                <li><a href="/privacy">PRIVACY POLICIES</a></li>
                <li><a href="/privacy">COPYRIGHT POLICIES</a></li>
              </ul>
            </div>
          </div>
          
          <div className="col-lg-5 col-md-6 mb-4">
            <div className="footer-section">
              <h5>TRAVEL DESTINATIONS</h5>
              <div className="destination-grid">
                {footerDestinations.map((destination, index) => (
                  <div 
                    key={index} 
                    className="footer-card" 
                    style={{ 
                      backgroundImage: `url('/placeholder.svg?height=70&width=100')`,
                      cursor: 'pointer'
                    }}
                    onClick={() => {
                      if (destination === 'CUSTOM') {
                        if (window.showContactCardOverlay) window.showContactCardOverlay();
                      } else {
                        handleDestinationClick(destination);
                      }
                    }}
                  >
                    <span>{destination}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <div className="logo-section-footer">
          <img 
            src="/assets/logo.png" 
            alt="Travelscape.com" 
            className="footer-logo"
          />
        </div>
        <div className="footer-contact">
          <p>For any queries, please contact us at:</p>
          <p className="footer-contact-text">
            <i className="fas fa-phone-alt"></i> +91 8799982010 / +91 9370292741
          </p>
        </div>

        <div className="social-icons">
          <a href="#" aria-label="Facebook"><i className="fab fa-facebook-f"></i></a>
          <a href="https://www.instagram.com/travelscape_official/" aria-label="Instagram"><i className="fab fa-instagram"></i></a>
          <a href="#" aria-label="Twitter"><i className="fab fa-twitter"></i></a>
          <a href="#" aria-label="LinkedIn"><i className="fab fa-linkedin-in"></i></a>
          <a href="#" aria-label="YouTube"><i className="fab fa-youtube"></i></a>
        </div>
        
        <p className="copyright">© 2025 Travelscapetours.com All rights reserved.</p>
      </div>
    </div>
  );
};

export default Footer;
